import { render, staticRenderFns } from "./PathwayCohortAddSectionModal.vue?vue&type=template&id=2c0331ae&"
import script from "./PathwayCohortAddSectionModal.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortAddSectionModal.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCohortAddSectionModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports